import {
  AddonFooter,
  Appear,
  AppLayout,
  AppLayoutBody,
  AppLayoutHeader,
  AppLayoutMain,
  Flex,
  Icon,
  Text,
} from '@bitrise/bitkit';
import React, { useContext, FunctionComponent } from 'react';
import { Switch, Redirect, Route, useParams } from 'react-router-dom';
import AppBeam from '../App/AppBeam';
import { AuthContextFirebase } from '../Authenticate/AuthenticateFirebase';
import GettingStarted from './GettingStarted/GettingStarted';
import TermsOfService from './TermsOfService/TermsOfService';
import './Onboarding.css';

export type TypeOnboardingSetupOption = 'cocoapods' | 'spm' | 'step' | 'gradle';

const Onboarding: FunctionComponent = () => {
  const { appId } = useParams<{ appId: string }>();
  const {
    data: { hasAgreedTermsOfService },
  } = useContext(AuthContextFirebase);

  return (
    <AppLayout backgroundColor="grape-5">
      <AppLayoutHeader>
        <AppBeam />
      </AppLayoutHeader>

      <AppLayoutBody>
        <AppLayoutMain initial="none">
          <Flex className="Onboarding" grow paddingHorizontal="x6">
            <Appear animation="Fade" duration="fast" paddingVertical="x10" textColor="grape-1">
              <Flex alignChildren="middle" container direction="horizontal">
                <Flex className="Onboarding__icon-1">
                  <Icon name="Bitbot" size="4.25rem" />
                </Flex>

                <Flex absolute="center" className="Onboarding__icon-2">
                  <Icon name="Trace" size="3.5rem" />
                </Flex>
              </Flex>

              <Text align="middle" config="1">
                Welcome to Trace
              </Text>
              <Text align="middle" config="3" margin="x3">
                Monitoring made for mobile
              </Text>
            </Appear>

            <Switch>
              {!hasAgreedTermsOfService && (
                <Redirect from={`/${appId}/o/getting-started`} to={`/${appId}/o/welcome`} />
              )}
              <Route component={GettingStarted} path="/:appId/o/getting-started" />
              <Route component={TermsOfService} path="/:appId/o/welcome" />
            </Switch>

            <AddonFooter addonName="Trace" margin="x16" paddingVertical="x16" textColor="white" />
          </Flex>
        </AppLayoutMain>
      </AppLayoutBody>
    </AppLayout>
  );
};

export default Onboarding;
